const ALL = 'All';
const EASY = 'easy';
const FAST = 'fast';
const BRANDS = 'brands';
const TENANTS = 'tenants';
const SERVICES = 'services';
const TENANTS_AND_SERVICES = 'tenants-and-services';
const BRANDS_TENANTS_CATEGORIES = 'brands-tenants-categories';
const BRANDS_TENANTS_CATEGORIES_SERVICES = 'brands-tenants-categories-services';
// TODO: load from translation string
const ALL_LETTERS = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

export {
    ALL,
    EASY,
    FAST,
    BRANDS,
    TENANTS,
    SERVICES,
    ALL_LETTERS,
    TENANTS_AND_SERVICES,
    BRANDS_TENANTS_CATEGORIES,
    BRANDS_TENANTS_CATEGORIES_SERVICES
};
